import { Boundaries } from "@planzone/core";
import { State } from "./types";

function handleRemoveProject(
  state: State,
  project: Boundaries["removeProject"]["success"],
): State {
  return state.map((req) => ({
    ...req,
    zones: req.zones.map((z) => ({
      ...z,
      projects: z.projects.filter(({ uuid }) => uuid !== project.uuid),
    })),
  }));
}
export { handleRemoveProject };
